<p-card>
    <!-- Mobile Menu Button -->
    <div class="lg:hidden mb-3">
        <p-button 
            icon="pi pi-bars" 
            label="Menu Administration" 
            (onClick)="toggleSidebar()"
            styleClass="w-full"
            severity="secondary">
        </p-button>
    </div>

    <!-- Mobile Sidebar -->
    <p-sidebar [(visible)]="sidebarVisible" position="left" [modal]="true">
        <ng-template pTemplate="header">
            <h5>Administration</h5>
        </ng-template>
        <p-panelMenu [model]="menu" class="w-full">
            <ng-template pTemplate="item" let-item>
                <ng-container *ngIf="item.route; else urlRef">
                    <a [routerLink]="item.route" class="flex align-items-center 
                        cursor-pointer text-color px-3 py-2">
                        <span [class]="item.icon"></span>
                        <span class="ml-2 text-color">{{ item.label }}</span>
                    </a>
                </ng-container>
                <ng-template #urlRef>
                    <a *ngIf="item.url; else noLink" [href]="item.url" class="flex align-items-center 
                        cursor-pointer text-color px-3 py-2">
                        <span [class]="item.icon"></span>
                        <span class="ml-2">{{ item.label }}</span>
                    </a>
                    <ng-template #noLink>
                        <span class="flex align-items-center cursor-pointer text-color px-3 py-2">
                            <span [class]="item.icon"></span>
                            <span class="ml-2">{{ item.label }}</span>
                            <i *ngIf="item.items" class="pi pi-angle-down text-primary ml-auto"></i>
                        </span>
                    </ng-template>
                </ng-template>
            </ng-template>
        </p-panelMenu>
    </p-sidebar>

    <div class="grid">
        <!-- Desktop Menu (hidden on mobile) -->
        <div class="hidden lg:block lg:col-2">
            <h5>Administration</h5>
            <p-panelMenu [model]="menu" class="w-full md:w-20rem">
                <ng-template pTemplate="item" let-item>
                    <ng-container *ngIf="item.route; else urlRef">
                        <a [routerLink]="item.route" class="flex align-items-center 
                            cursor-pointer text-color px-3 py-2">
                            <span [class]="item.icon"></span>
                            <span class="ml-2 text-color">{{ item.label }}</span>
                        </a>
                    </ng-container>
                    <ng-template #urlRef>
                        <a *ngIf="item.url; else noLink" [href]="item.url" class="flex align-items-center 
                            cursor-pointer text-color px-3 py-2">
                            <span [class]="item.icon"></span>
                            <span class="ml-2">{{ item.label }}</span>
                        </a>
                        <ng-template #noLink>
                            <span class="flex align-items-center cursor-pointer text-color px-3 py-2">
                                <span [class]="item.icon"></span>
                                <span class="ml-2">{{ item.label }}</span>
                                <i *ngIf="item.items" class="pi pi-angle-down text-primary ml-auto"></i>
                            </span>
                        </ng-template>
                    </ng-template>
                </ng-template>
            </p-panelMenu>
        </div>
        <!-- Content Area (full width on mobile, 10 cols on desktop) -->
        <div class="col-12 lg:col-10">
            <p *ngIf="!routerService.url.includes('/admin/')" class="text-center mt-5">Sélectionnez une option du menu d'administration</p>
            <router-outlet></router-outlet>
        </div>
    </div>
</p-card>